import { SidebarHeaderProps } from '.';

// This object should contain a mock value for each required prop of this component
export const requiredProps: SidebarHeaderProps = {};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as SidebarHeaderProps,
  },
];

export const testkitTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
      title: 'test',
    } as SidebarHeaderProps,
  },
];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
